import { ReactElement } from 'react'

import { IR_LIBRARY_ROUTE } from '@/utils/routes'

import { LinkCard } from '@/components/elements/LinkCard'
import { LinkCardList } from '@/components/elements/LinkCardList'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Layout } from '@/components/layouts/Ir'
import { DownloadZipButton } from '@/components/layouts/Ir/Mpocket/DownloadZipButton'

import { useMpocketScript } from '@/hooks/useMpocketScript'

export const IrLibraryPage = () => {
  useMpocketScript('//irpocket.com/141A/irpocket/config-utils-main.js')
  // useMpocketScript('//irpocket.com/5882/irpocket/config-utils-main.js')

  return (
    <Layout>
      <SectionTitle
        color="normal"
        titleText="IR Library"
        subTitleText="IRライブラリー"
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <LinkCardList>
        {IR_LIBRARY_ROUTE.subdirectories.map(
          ({ path, name, imagePath, ...other }) => (
            <LinkCard
              link={path}
              title={name}
              imgPath={imagePath}
              {...other}
              key={path}
            />
          )
        )}
      </LinkCardList>
      <Spacer h={{ sp: 26, pc: 46 }} />
      <DownloadZipButton id="irp-library-latest-zip" />
    </Layout>
  )
}
IrLibraryPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '株主・投資家向け情報', path: '/ir' },
    { name: 'IRライブラリー', path: '' },
  ]

  return (
    <>
      <Head
        title="IRライブラリー"
        description="トライアルホールディングスのIR関連資料をまとめて掲載しています。"
        ogp={{ url: '/ir/library/' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle="株主・投資家向け情報"
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
